function startsWith(str, prefix) {
    return str.slice(0, prefix.length) === prefix;
}

export { startsWith };
